<!--
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-08-16 08:53:31
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-13 16:08:44
-->
<template>
  <div class="root">
    <div>
      <span>{{ detail.style == 1 ? "转出" : "需求" }}标的名称：</span>
      <p>{{ detail.projectName }}</p>
    </div>
    <div>
      <span>鉴证编号：</span>
      <p>{{ detail.attestCode }}</p>
    </div>
    <div>
      <span>项目编号：</span>
      <p>{{ detail.projectNumber }}</p>
    </div>
    <div>
      <span>签约日期：</span>
      <p>{{ detail.signDate }}</p>
    </div>
    <div>
      <span>{{ detail.style == 1 ? "转出方" : "提供方" }}：</span>
      <p>{{ detail.outName }}</p>
    </div>
    <div>
      <span>{{ detail.style == 1 ? "受让方" : "需求方" }}：</span>
      <p>{{ detail.needName }}</p>
    </div>
    <div>
      <span>成交金额：</span>
      <p>{{ detail.dealMonry }} 元</p>
    </div>
    <div>
      <span>成交方式：</span>
      <p>{{ detail.dealType }}</p>
    </div>
    <div>
      <span>发布时间：</span>
      <p>{{ detail.signDate }}</p>
    </div>
    <div v-if="detail.outType != 2">
      <span>合同起止日期：</span>
      <p>{{ detail.outDuration }}</p>
    </div>
  </div>
</template>

<script>
import request from '@/util/request'
export default {
  data () {
    return {
      detail: {},
    }
  },
  created () {
    // let id = this.$route.query.id;
    // let url = 'jianzhengshuxiangqing';
    // console.log(this.ajax_id(url,id).data);
    // this.detail = this.ajax_id(url, id).data;
    request({
      url: '/api/attestDetail',
      method: 'post',
      data: {
        id: this.$route.query.id
      }
    }).then(res => {
      console.log('鉴证书详情', res)
      this.detail = res.data.data
    })
  },
  mounted () {
  },
  computed: {},
  watch: {},
  methods: {
    // 获取字典内容方法
    getDictsVal (list, val) {
      if (!!list && !!val) {
        return list.filter((item) => {
          return item.dictValue == val
        })[0]
          ? list.filter((item) => {
            return item.dictValue == val
          })[0].dictLabel
          : ""
      }
      return ""
    },
  },
};
</script>

<style scoped>
.root {
  /* min-height: 1180px; */
  margin: 0 auto;
  margin-bottom: 30px;
  padding: 40px 100px 60px 285px;
  width: 1475px;
  min-height: 716px;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
}

.root div {
  width: 1300px;
  /* height: 26px; */
  font-size: 24px;
  font-family: MicrosoftYaHei;
  color: #333333;
  letter-spacing: 2px;
  margin-bottom: 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid rgb(210, 210, 210);
}

.root div span {
  /* display:  block; */
  width: 160px;
  height: 26px;
  white-space: nowrap;
  /* padding-right: 10px; */
  color: #151515;
  text-align-last: justify;
  text-justify: distribute-all-lines;
  /* 这行bai必加，兼容ie浏览器 */
  background-color: #f3f5f8;
  display: inline-block;
  align-items: center;
  text-align: center;
  line-height: 26px;
  padding: 24px;
  font-weight: 600;
}

.root div p {
  /* display:  block; */
  width: 1040px;
  height: auto;
  padding: 21px;
}
</style>
